import { render, staticRenderFns } from "./ContactCode.vue?vue&type=template&id=33d3b444&scoped=true"
import script from "./ContactCode.vue?vue&type=script&lang=js"
export * from "./ContactCode.vue?vue&type=script&lang=js"
import style0 from "./ContactCode.vue?vue&type=style&index=0&id=33d3b444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d3b444",
  null
  
)

export default component.exports